import 'aos/dist/aos.css'
import shotArrow from '../Assets/shotarrow.png'
import './Aboutme.css'
import SideImg from '../Assets/sideimg.png'
import ImageSide from '../Assets/imageside.png'
const Aboutme = () => {
  return (
    <div className="allaboutme">
      <div className="coloredsess">
        <div className="hiretext">
          {/* <p className="coloredabout">About me</p> */}
          <p className="catchphrase">
            I consistently deliver results that exceed expectations.
          </p>
          <div data-aos="fade-up">
            <div class="viewbtnlg">
              <a href="mailto:paulanimashaun20@gmail.com" class="viewshotalg">
                <button class="viewshotabtnlg">
                  <p class="viewshotplg">Hire Me!</p>
                  <div class="shotarrow">
                    <img src={shotArrow} alt="arrow" />
                    <img src={shotArrow} alt="arrow" />
                  </div>
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="sideimg">
          <img src={ImageSide} alt="bannersection" />
        </div>
      </div>
      <div className="aboutmendimg">
        <div class="sideimg2">
          <img src={SideImg} alt="bannersection" />
        </div>
        <p data-aos="fade-up" class="aboutmep">
          Hi, I’m Paul Anny — a passionate and thoughtful{' '}
          <strong>Graphic and Brand Designer</strong> with over 4 years of
          experience bringing brands to life. I specialize in creating
          compelling visual identities through branding, logos, and digital
          design that go beyond aesthetics to truly resonate with audiences.
          With a deep understanding of human behavior and strategic
          storytelling, I craft designs that don’t just look good but
          communicate meaning and build connection. Every project is tailored to
          reflect the heart of the brand, ensuring thoughtful, effective, and
          memorable results.
        </p>
      </div>
    </div>
  )
}

export default Aboutme
